export default [
	{
		value: 1,
		label: "Simples Nacional."
	},
	{
		value: 2,
		label: "Simples Nacional - excesso de sublimite da receita bruta."
	},
	{
		value: 3,
		label: "Regime Normal."
	}
];



// WEBPACK FOOTER //
// ./src/components/parts/person/personAdaptToCompany/crt/codes.js